import { IceConfigError } from './errors.js';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const parseIceServer = (value: unknown): RTCIceServer => {
  if (!isRecord(value) || !Array.isArray(value['urls'])) {
    throw new IceConfigError(`Malformed ICE server entry: ${JSON.stringify(value)}`);
  }
  const urls = value['urls'].filter((url): url is string => typeof url === 'string');
  const server: RTCIceServer = { urls };
  if (typeof value['username'] === 'string' && typeof value['credential'] === 'string') {
    return { ...server, username: value['username'], credential: value['credential'] };
  }
  return server;
};

export const parseIceServers = (body: unknown): RTCIceServer[] => {
  if (!isRecord(body) || !Array.isArray(body['iceServers'])) {
    throw new IceConfigError(`ICE config response is malformed: ${JSON.stringify(body)}`);
  }
  return body['iceServers'].map(parseIceServer);
};

export const fetchIceServers = async (): Promise<RTCIceServer[]> => {
  const response = await fetch('/api/ice', { cache: 'no-store' });
  if (!response.ok) {
    throw new IceConfigError(`GET /api/ice failed with status ${response.status}: ${await response.text()}`);
  }
  return parseIceServers(await response.json());
};
